const routes = {
  home: {
    text: 'shared.home',
    id: 'home',
  },
  about: {
    text: 'shared.about',
    id: 'about',
  },
  work: {
    text: 'shared.projects',
    id: 'work',
  },
  contact: {
    text: 'shared.contact',
    id: 'contact',
  },
}

export default routes
